import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import {Service} from 'axios-middleware';
import store from './store/store';

const baseURL = process.env.VUE_APP_BACKEND_APP_URL;
console.log(baseURL);

const service = new Service(axios);
const devMode = process.env.NODE_ENV === 'development';

if (!devMode) {
  service.register({
    onResponseError(err) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        store.commit('login/logout');
      }
    }
  });
}
const CONFIG = {
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
};

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = baseURL;
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common["Access-Control-Allow-Origin"] = '*';
    Vue.axios.defaults.headers.common["Access-Control-Allow-Methods"] = 'GET, POST, PATCH, PUT, DELETE, OPTIONS';
    Vue.axios.defaults.headers.common["Access-Control-Allow-Headers"] = 'Origin, Content-Type, X-Auth-Token';
    Vue.axios.defaults.headers.common["Content-Type"] = 'application/json';
    Vue.axios.defaults.headers.common["Authorization"] = 'Bearer ' + localStorage.getItem('token');
  },

  query(resource, params, config=CONFIG) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
    return Vue.axios.get(resource, params, config).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @param config
   * @returns {*}
   */
  get(resource, slug = "", config=CONFIG) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
    return Vue.axios.get(`${resource}${slug ? '/' : ''}${slug}`, config).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @param config
   * @returns {*}
   */
  post(resource, params, config=CONFIG) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
    return Vue.axios.post(`${resource}`, params, config);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @param config
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params, config=CONFIG) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
    return Vue.axios.put(`${resource}${slug ? '/' : ''}${slug}`, params, config);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @param config
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params, config=CONFIG) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
    return Vue.axios.put(`${resource}`, params, config);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @param config
   * @returns {*}
   */
  delete(resource, config=CONFIG) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
    return Vue.axios.delete(resource, config).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
